import { api } from '@mmef/shared/api';
import type { SavedEventSummary } from '@mmef/shared/api';

export const savedEventsApi = api.injectEndpoints({
  endpoints: (build) => ({
    listSavedEvents: build.query<SavedEventSummary[], void>({
      query: () => '/me/saved-events',
      providesTags: [{ type: 'SavedEvents', id: 'LIST' }],
    }),

    saveEvent: build.mutation<void, number>({
      // PUT, because saving twice means the same as saving once.
      query: (eventId) => ({ url: `/me/saved-events/${eventId}`, method: 'PUT' }),
      invalidatesTags: [{ type: 'SavedEvents', id: 'LIST' }],
    }),

    unsaveEvent: build.mutation<void, number>({
      query: (eventId) => ({ url: `/me/saved-events/${eventId}`, method: 'DELETE' }),
      invalidatesTags: [{ type: 'SavedEvents', id: 'LIST' }],
    }),

    /**
     * Removes a bookmark by its own id rather than the event's — the only way to delete one whose
     * event has since been removed from the catalogue, since those have no event id left.
     */
    removeSavedEntry: build.mutation<void, number>({
      query: (savedEventId) => ({ url: `/me/saved-events/entries/${savedEventId}`, method: 'DELETE' }),
      invalidatesTags: [{ type: 'SavedEvents', id: 'LIST' }],
    }),
  }),
});

export const {
  useListSavedEventsQuery,
  useSaveEventMutation,
  useUnsaveEventMutation,
  useRemoveSavedEntryMutation,
} = savedEventsApi;
